import { inject } from "mobx-react";
import {
  SecuredMenuFunctionalButton,
  SecuredMenuLinkButton
} from "lego-gui-lib";
import React from "react";

export const RowButton = inject("i18n")(
  ({ i18n, title: titleArgs, ...props }) => {
    const title = i18n.t(...titleArgs);
    return (
      <>
        {props.link ? (
          <SecuredMenuLinkButton title={title} {...props} />
        ) : (
          <SecuredMenuFunctionalButton title={title} {...props} />
        )}
      </>
    );
  }
);
